import { Cryptocoin } from "@models";
import { TRADABLES_TYPE } from "@helpers/constants";
import { TradableDetailInterface, TradableDetailType } from "@models/interfaces/tradable_detail_types";

export class SecurityToken extends Cryptocoin {
	protected static readonly currencyType: string = TRADABLES_TYPE.SECURITY_TOKEN;
	protected readonly tradable_actions: string[] = ["buy", "sell"];

	public readonly tradableDetailLabels: TradableDetailInterface[] = [
		{
			label: "daily_high",
			translationKey: "tradable_detail_label_daily_high",
			type: TradableDetailType.FIAT
		},
		{
			label: "daily_low",
			translationKey: "tradable_detail_label_daily_low",
			type: TradableDetailType.FIAT
		},
		{
			label: "high_52_w",
			translationKey: "tradable_detail_label_high_52_w",
			type: TradableDetailType.FIAT
		},
		{
			label: "low_52_w",
			translationKey: "tradable_detail_label_low_52_w",
			type: TradableDetailType.FIAT
		},
		{
			label: "monthly_volatility",
			translationKey: "tradable_detail_label_monthly_volatility",
			type: TradableDetailType.PERCENTAGE
		}
	];

	public getCurrencyType(): string {
		return SecurityToken.currencyType;
	}
}
